<template>
  <div class="draw_container">
    <div class="content" @click="share">
      <div class="content-bg">
        <div class="info">
          <div class="img_header"><img :src="avatar" alt="" /></div>
          <div class="text">
            <p class="name">
              <span>{{ username }}</span
              ><i :class="['icon', gender == 1? 'man' : 'woman']"></i
              ><span class="name_text">邀请你一起来玩游戏!</span>
            </p>
            <span class="roomnum">房间号:{{ lrsRoomId }}</span>
            <span class="password" v-show="pwd && pwd !== 'null' ? true : false"
              >密码:{{ pwd }}</span
            >
          </div>
        </div>
        <p class="btn" @click="share"></p>
      </div>
    </div>
    <Appopen
      :title="'我是谜app打开方式'"
      :browser="'1.点击右上角[...]'"
      :direct="'2. 选择[在浏览器中打开]'"
      :isAppopen="isAppopen"
      :num="'房间号:' + lrsRoomId"
    ></Appopen>
  </div>
</template>
<script>
import axios from "axios";
import { appUrlAndroid, appUrlIOS } from "../../assets/js/base64";
export default {
  data() {
    return {
      avatar: "",
      username: "",
      lrsRoomId: "",
      pwd: "",
      isAppopen: false,
      gender: ''
    };
  },
  created() {
    document.getElementsByTagName("title")[0].innerText = "你画我猜";
    var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    this.userId = this.$route.query.id;
    this.room = this.$route.query.num;
    this.pwd = this.$route.query.pwd ? this.$route.query.pwd : "";
    this.getShareInfo();
  },
  components: {
    Appopen: () => import("../../component/Appopen.vue")
  },
  methods: {
    getShareInfo() {
      axios
        .post(this.$interfaces.getDrawInfo, { userId: this.userId })
        .then(res => {
          let data = res.data.data;
          this.avatar = data.user.avatar;
          this.username = data.user.nickname;
          this.lrsRoomId = data.roomId ? data.roomId : this.room;
          this.gender = data.user.gender ? data.user.gender : 1
        })
        .catch(err => {
          console.log(err);
        });
    },
    share() {
      this.baseUrl = "https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan";
      if (this.isAndroid) {
        window.location.href =
          this.baseUrl +
          `&android_schema=${appUrlAndroid(
            "270000",
            "roomId=" + this.lrsRoomId
          )}`;
      } else if (this.isiOS) {
        let ua = navigator.userAgent.toLowerCase();
        if (ua.match(/QQ/i) == "qq") {
          this.isAppopen = true;
        } else {
          window.location.href = appUrlIOS(
            "270000",
            "roomId=" + this.lrsRoomId
          );
        }
      } else {
        window.location.href = "http://share.xiyacs.com/#/open";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/base.css";
.draw_container {
  width: 100vw;
  height: 100vh;
  .content {
    background: url("../../assets/images/nhwc/share/yqhy_bj_an@2x.png") no-repeat;
    width: 100vw;
    height: 33.35rem;
    background-size: cover;
    text-align: center;
    padding-top: 2.5rem;
    padding-right: 1.5rem;
    padding-left: 1.5rem;
    .content-bg {
      position: relative;
      display: inline-block;
      width: 15.75rem;
      height: 21rem;
      background: url("../../assets/images/nhwc/share/yqhy_bt_an@2x.png") no-repeat;
      background-size: cover;
      .btn {
        position: absolute;
        background: url("../../assets/images/nhwc/share/yqhy_jr_an@2x.png") no-repeat;
        background-size: cover;
        width: 12.95rem;
        height: 2.7rem;
        left: 50%;
        bottom: 1.3rem;
        transform: translateX(-50%);
      }
      .info {
        position: absolute;
        top: 1.1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 2.325rem;
        width: 13.75rem;
        left: 50%;
        transform: translateX(-50%);
        .img_header {
          background: url("../../assets/images/nhwc/share/Oval20@2x.png") no-repeat;
          background-size: cover;
          width: 2.5rem;
          height: 2.5rem;
          margin-right: 0.5rem;
          border-radius: 50%;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }
        .text {
          font-size: 0.8rem;
          width: 10.875rem;
          height: 2.475rem;
          font-family: "PingFangSC-Medium,PingFang SC";
          font-weight: 500;
          color: rgba(64, 72, 82, 1);
          display: inline-block;
          text-align: left;
          .name {
            padding-top: 0.25rem;
            line-height: 0.975rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .icon {
              width: 0.8rem;
              height: 0.8rem;
              &.woman {
                background: url("../../assets/images/nhwc/share/personal_girl_tips@2x.png")
                  no-repeat;
                background-size: cover;
              }
              &.man {
                background: url("../../assets/images/nhwc/share/personal_boy_tips@2x.png")
                  no-repeat;
                background-size: cover;
              }
            }
            span {
              display: inline-block;
              text-align: center;
              width: 2.5rem;
              height: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .name_text {
              text-align: left;
              flex: 1;
            }
          }
          .roomnum,
          .password {
            height: 0.925rem;
            font-size: 0.65rem;
            font-family: "PingFangSC-Regular,PingFang SC";
            font-weight: bold;
            color: rgba(161, 168, 179, 1);
            line-height: 0.65rem;
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          }
          .password {
            margin-left: 0.5rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/draw/draw_share.vue